import React from "react";
import { useTranslation } from "react-i18next";

import { Button } from "./ui/button";

interface TourCardProps {
  image: string;
  title: string;
  description: string;
}

const TourCardComponent = ({ image, title, description }: TourCardProps) => {
  const { t } = useTranslation();

  return (
    <article className="flex h-full flex-col overflow-hidden rounded-3xl bg-white shadow-xl">
      <div className="relative h-48 w-full overflow-hidden">
        <img src={image} alt={title} className="h-full w-full object-cover" loading="lazy" />
        <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent" />
      </div>
      <div className="flex flex-1 flex-col gap-4 p-6">
        <h3 className="text-xl font-semibold text-slate-900">{title}</h3>
        <p className="text-sm text-slate-600">{description}</p>
        <Button asChild className="mt-auto w-full">
          <a href="https://wa.me/5548996523066" target="_blank" rel="noreferrer">
            {t("tours.interestBtn")}
          </a>
        </Button>
      </div>
    </article>
  );
};

export default TourCardComponent;
